/**
 * Resource names for render graph history resources.
 * @public
 */ const RGHistoryResources = {
    TAA_COLOR: 'taaColor',
    TAA_MOTION_VECTOR: 'taaMotionVector',
    SSR_REFLECT: 'ssrReflect',
    SSR_MOTION_VECTOR: 'ssrMotionVector'
};

export { RGHistoryResources };
//# sourceMappingURL=history_resources.js.map
